export default __webpack_public_path__ + "static/media/logoroutes.fb97a28b.png";